// import component
import VariableCategoryColorMap from "../../../utils/VariableCategoryColorMap";
import DriverAnalysisChart from "./DriverAnalysisChart";

//Props Validations
import PropTypes from "prop-types";

function DriverAnalysisCategory({ data = {} }) {
    const { name, value, image, options, color, imageStyle } = data;
    return (
        <div
            style={{
                padding: "10px 20px",
            }}
        >
            <div
                style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    height: "100%",
                    border: `1px solid ${color}`,
                    borderRadius: "4px",
                }}
            >
                <div
                    style={{
                        padding: "10px",
                        textAlign: "center",
                    }}
                >
                    <img
                        src={image}
                        style={{
                            width: "80px",
                            ...imageStyle,
                        }}
                    />
                    <p
                        style={{
                            color: "#495057",
                            fontSize: "14px",
                            height: 40,
                        }}
                    >
                        {name}
                    </p>
                    <DriverAnalysisChart
                        value={value}
                        color={color}
                    />
                </div>
                <div
                    style={{
                        padding: "12px",
                        height: "100%",
                        backgroundImage: `linear-gradient(${color}, #FFFFFF)`,
                    }}
                >
                    <ul
                        style={{
                            paddingLeft: "10px",
                            paddingRight: "10px",
                        }}
                    >
                        {options.map((option, index) => {
                            const [_option, kpiData] = option.split("*-*");
                            return (
                                <li
                                    key={index}
                                    style={{ fontSize: "14px" }}
                                >
                                    {_option}
                                    <span
                                        style={{
                                            color: VariableCategoryColorMap?.[kpiData],
                                        }}
                                    >
                                        &nbsp;{kpiData}
                                    </span>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
}

// Typechecking props for the DriverAnalysisCategory
DriverAnalysisCategory.propTypes = {
    data: PropTypes.object,
};

export default DriverAnalysisCategory;
